import React from 'react';
import DataProvider from '../../Data/DataProvider';
import SearchBar from '../../SearchBar/SearchBar';
import Carousel from '../../Carousel/Carousel';
import { useIsMobile } from '../../../hooks/useIsMobile';
import "./PodcastGuestSearch.css";

export default function PodcastGuestSearch() {
  const isMobile = useIsMobile();

  return (
    <DataProvider>
      {({
        experts,
        loading,
        error,
        activeCategory,
        setActiveCategory,
        categories,
        handleNext,
        handlePrev,
        searchQuery,
        setSearchQuery,
        handleSearch,
        isSearchMode,
        resetSearch,
        displayedExperts = experts,
        loadMore = handleNext,
        hasMore = true,
        sendToIntercom = false
      }) => {
        const params = new URLSearchParams(window.location.search);
        const GLOBE_ICON_URL =
          params.get('globe_icon_url') ||
          'https://qwotedstg.wpenginepowered.com/wp-content/uploads/2025/04/globe-1.svg';

        const visibleCategories = categories.map((cat) => ({
          name: cat.label,
          icon: cat.icon || GLOBE_ICON_URL,
        }));

        const handleTagSearch = (tagString) => {
          setSearchQuery(tagString);
          handleSearch(tagString);
        };

        const activeLabel =
          categories.find((c) => c.key === activeCategory)?.label || "All";

        // Only preload on initial "All" (and not during searches)
        const isAll = String(activeCategory || "all").toLowerCase() === "all";
        const enablePreloads = isAll && !isSearchMode;

        // ✅ Make onSearchSubmit pass the term
        const onSearchSubmit = (term) => {
          const q = typeof term === 'string' ? term : searchQuery;
          setSearchQuery(q);
          handleSearch(q); // DataProvider will run semantic search (see next section)
        };

        return (
          <>
            {isMobile ? (
              <>
                <SearchBar
                  categories={visibleCategories}
                  activeCategory={activeLabel}
                  onChangeCategory={(label) => {
                    const found = categories.find((c) => c.label === label);
                    if (found) setActiveCategory(found.key);
                  }}
                  searchTerm={searchQuery}
                  onSearchChange={setSearchQuery}
                  onSearchSubmit={onSearchSubmit}
                  isSearchMode={isSearchMode}
                  onReset={resetSearch}
                />
                <div className='mobile-space' />
                <Carousel
                  items={displayedExperts}
                  loading={loading}
                  error={error}
                  loadMore={loadMore}
                  hasMore={hasMore}
                  onNext={handleNext}
                  onPrev={handlePrev}
                  onTagClick={handleTagSearch}
                  enablePreloads={enablePreloads}
                  sendToIntercom={sendToIntercom}
                />
                <div className="signup-cta">
                  Looking to be featured as an expert?{' '}
                  <a
                    href="https://app.qwoted.com/users/sign_up?_gl=1*1yr8hb8*_gcl_au*MzY0NTUwMjIwLjE3NTU3OTM1NTguMjEyMjcwNjM1OC4xNzYwMzE0Njk1LjE3NjAzMTQ2OTQ.*_ga*Mjg2NTc3MDUzLjE3NDA0MzQwMTE.*_ga_MB00LK3EHV*czE3NjAzODE2ODEkbzE5JGcxJHQxNzYwMzgzNDAzJGo1NCRsMCRoMA.."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="signup-link"
                  >
                    Sign up here →
                  </a>
                </div>
              </>
            ) : (
              <>
                <SearchBar
                  categories={visibleCategories}
                  activeCategory={activeLabel}
                  onChangeCategory={(label) => {
                    const found = categories.find((c) => c.label === label);
                    if (found) setActiveCategory(found.key);
                  }}
                  searchTerm={searchQuery}
                  onSearchChange={setSearchQuery}
                  onSearchSubmit={onSearchSubmit}
                  isSearchMode={isSearchMode}
                  onReset={resetSearch}
                />
                <Carousel
                  items={displayedExperts}
                  loading={loading}
                  error={error}
                  loadMore={loadMore}
                  hasMore={hasMore}
                  onNext={handleNext}
                  onPrev={handlePrev}
                  onTagClick={handleTagSearch}
                  enablePreloads={enablePreloads}
                  sendToIntercom={sendToIntercom}
                />
                <div className="signup-cta">
                  Looking to be featured on a podcast as an expert?{' '}
                  <a
                    href="https://app.qwoted.com/users/sign_up?_gl=1*1yr8hb8*_gcl_au*MzY0NTUwMjIwLjE3NTU3OTM1NTguMjEyMjcwNjM1OC4xNzYwMzE0Njk1LjE3NjAzMTQ2OTQ.*_ga*Mjg2NTc3MDUzLjE3NDA0MzQwMTE.*_ga_MB00LK3EHV*czE3NjAzODE2ODEkbzE5JGcxJHQxNzYwMzgzNDAzJGo1NCRsMCRoMA.."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="signup-link"
                  >
                    Sign up here →
                  </a>
                </div>
              </>
            )}
          </>
        );
      }}
    </DataProvider>
  );
}
